import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, Image, Button } from '@chakra-ui/react';

import bigYellowHexa from '../Assets/Icons/bigHexa.svg';

import BlockItemCard from './BlockItemCard';
import ModalTemplate from '../../common/ModalTemplate';
import MegaPhone from '../../assets/icons/MegaPhone';
import BadgeAssessmentCard from './BadgeAssessmentCard';
import { useNavigate } from 'react-router-dom';
import { useDomainConfig } from '../../../hooks/useDomainConfig';
import { SAGEX_ORG_KEY } from '../../../utils/segexOrgName';

interface Props {
	blockData: any;
}

const BlockCard = ({ blockData }: Props) => {
	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	const [showComingSoonModal, setShowComingSoonModal] = useState(false);
	const navigate = useNavigate();
	const meta = blockData?.meta || {};
	const contestData = {
		name: meta.contestName,
		logo: meta.contestLogo,
		companyLine: meta.contestCompanyLine,
		companyLogo: meta.contestCompanyLogo,
		bgColor: meta.contestLogoBgColor,
		blockItemType: 'contest',
	};
	const quizData = {
		name: meta.quizName,
		logo: meta.quizLogo,
		companyLine: meta.quizCompanyLine,
		companyLogo: meta.quizCompanyLogo,
		bgColor: meta.quizLogoBgColor,
		blockItemType: 'quiz',
	};
	const lectureData = {
		name: meta.lectureName,
		logo: meta.lectureLogo,
		companyLine: meta.lectureCompanyLine,
		companyLogo: meta.lectureCompanyLogo,
		bgColor: meta.lectureLogoBgColor,
		blockItemType: 'lecture',
	};
	const resourceData = {
		name: meta.resourceName,
		logo: meta.resourceLogo,
		companyLine: meta.resourceCompanyLine,
		companyLogo: meta.resourceCompanyLogo,
		bgColor: meta.resourceLogoBgColor,
		blockItemType: 'resource',
	};

	const [badgeBlockItem, setBadgeBlockItem] = useState<any>();

	useEffect(() => {
		if (blockData?.blockItems) {
			const badgeBlockItem = blockData?.blockItems.find((blockItem: any) => blockItem?.assessment?.isBadge);
			setBadgeBlockItem(badgeBlockItem);
		}
	}, [blockData]);
	const isSagex = SAGEX_ORG_KEY === domainConfig?.key;
	return (
		<Box bg="white" display="flex" flexDir="column" w={'100%'} maxW="361px" border={`1px solid ${meta.bgColor}`} borderRadius={'8px'}>
			<Flex p={isSagex ? 0 : 3} minH={isSagex ? '0px' : '80px'} justifyContent={'space-between'} alignItems={'start'}>
				<Text color={meta.color} textStyle={'subtitle2'} fontSize="18px" lineHeight="28px" px={4} py={'2'}>
					{meta.blockName}
				</Text>

				{!isSagex && (
					<Flex alignItems={'start'} bg={'#FFF3CC'} p={2} gap={'4px'} borderRadius={'8px'}>
						<Image h="16px" src={meta?.blockBadgeIcon} alt="small hexagon" />
						<Text ml="4px" color={meta.color} textStyle={'body2-md'} fontSize="12px" lineHeight="16px">
							{meta.blockBadgeTitle}
						</Text>
					</Flex>
				)}
			</Flex>

			<Box mb="auto" p={isSagex ? 0 : 2} display={'grid'} gridTemplateColumns={'repeat(1,1fr)'} gap={isSagex ? '0px' : '12px'}>
				{[contestData, resourceData, quizData, lectureData].map(item => {
					const type = item.blockItemType;
					let totalBlockItems = 0;
					let completedBlockItems = 0;
					switch (type) {
						case 'contest':
							const blockItemsOfTypeContestAssessment = blockData?.blockItems?.filter(
								(blockItem: any) => blockItem?.assessment?.meta?.type.toLowerCase() === 'contest',
							);
							completedBlockItems = blockItemsOfTypeContestAssessment?.filter((blockItem: any) => blockItem?.assessment?.userAssessment)?.length;
							totalBlockItems = blockItemsOfTypeContestAssessment?.length;
							break;
						case 'quiz':
							const blockItemsOfTypeQuizAssessment = blockData?.blockItems?.filter(
								(blockItem: any) => blockItem?.assessment?.meta?.type.toLowerCase() === 'quiz',
							);
							completedBlockItems = blockItemsOfTypeQuizAssessment?.filter((blockItem: any) => blockItem?.assessment?.userAssessment)?.length;
							totalBlockItems = blockItemsOfTypeQuizAssessment?.length;
							break;
						case 'lecture':
							const blockItemsOfTypeLecture = blockData?.blockItems?.filter((blockItem: any) => blockItem?.type.toLowerCase() === 'lecture');
							totalBlockItems = blockItemsOfTypeLecture?.length;
							break;
						case 'resource':
							const blockItemsOfTypeResource = blockData?.blockItems?.filter((blockItem: any) => blockItem?.type.toLowerCase() === 'resource');
							totalBlockItems = blockItemsOfTypeResource?.length;
							break;
					}
					if (totalBlockItems > 0)
						return <BlockItemCard completedBlockItems={completedBlockItems} totalBlockItems={totalBlockItems} blockId={blockData._id} data={item} />;
					else return <Box minH={isSagex ? '0px' : '70px'} order="10"></Box>;
				})}
			</Box>

			{!isSagex && <BadgeAssessmentCard blockItem={badgeBlockItem} meta={meta} setShowComingSoonModal={setShowComingSoonModal} />}

			<ModalTemplate
				title=""
				marginX={2}
				paddingY="16px"
				isOpen={showComingSoonModal}
				bgColor="white"
				maxWidth="343px"
				showCloseButton={true}
				showCloseButtonIcon={true}
				modalOverlayProps={{ bg: 'rgba(1, 10, 27, 0.80)' }}
				onClose={() => setShowComingSoonModal(false)}
			>
				<Box textAlign="center">
					<Box p="12px" bg="#F6EDE7" boxSize="68px" mx="auto" rounded="100px" color="#4358F6">
						<MegaPhone boxSize="45.5px" />
					</Box>
					<Text mt="16px" as="h4" textStyle="h4" color="#CC926E">
						Interview Expert Badge
					</Text>
					<Text mt="10px" textStyle="body1-md">
						Earn the other 4 badges and become eligible to unlock this badge after 7 working days.
					</Text>

					<Button
						onClick={() => {
							setShowComingSoonModal(false);
							// navigate('/dashboard');
							// navigate('/dashboard');
						}}
						w="full"
						mt="16px"
						variant="primary"
						bg="#4358F6"
					>
						Continue Practicing
					</Button>
				</Box>
			</ModalTemplate>
		</Box>
	);
};

export default BlockCard;
